export default __webpack_public_path__ + "static/media/rpg.02f9898a.png";